import {LOGIN_USER_SUCCESS, LOGIN_USER_ERROR, LOGIN_START, LOGOUT_USER, LOGIN_BACKEND_PICKED, LOGIN_SELECT_DEFAULT_BACKEND} from '../constants/Constants';
import api from '../api';
import settings from '../components/settings'

let rolemap = {
  'USER': 0,
  'INSTALLER': 1,
  'INSTALLER_COMPANY': 2,
  'ZEHNDER': 3,
  'ADMIN': 4
};

export function roleLargerThan(a, b) {
  if (rolemap[a] > rolemap[b]) {
    return true;
  }
  return false;
}

function largestrole(roles) {
  let ret;
  for (let i = 0; i < roles.length; i++) {
    if (!ret) {
      ret = roles[i];
      continue;
    }
    if (rolemap[roles[i]] > rolemap[ret]) {
      ret = roles[i];
    }
  }
  return ret;
}

export default function LoginStore(state = {inprogress: false}, action = null) {
  switch (action.type) {

    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        inprogress: false,
        config: action.user.backends.length == 1 ? action.user.backends[0] : undefined,
        user: action.user,
        jwt: action.jwt,
        largestrole: largestrole(action.user.roles)
      };

    case LOGIN_USER_ERROR:
      return {
        ...state,
        inprogress: false,
        user: null,
        jwt: null
      };

    case LOGIN_START:
      return {
        ...state,
        inprogress: true
      };

    case LOGOUT_USER:

      api.useConfig(null);
      return {
        ...state,
        inprogress: false,
        user: null,
        config: null,
        jwt: null
      };

    case LOGIN_BACKEND_PICKED:

      return {
        ...state,
        config: action.backend
      };

    case LOGIN_SELECT_DEFAULT_BACKEND:
      return state;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /src/reducers/LoginReducer.js